<template>
  <div>
    <div class="us-toggle-company" >
      <select id="us-select" style="color:#ccc;width:100%;outline:none;" v-if="loading"  >
        <option value="" >正在加载...</option>
      </select>
      <select id="us-select" style="color:#808080;width:100%;outline:none;" v-model="selectVal" @change="changeCompany" v-else >
        <option :value="item.value" v-for="(item,index) in companyList" :key="index">{{item.label}}</option>
      </select>
      <i class="fa fa-angle-down" aria-hidden="true" style="font-size:1.2rem;color:#808080;position:absolute;right:1.2rem;pointer-events:none;" ></i>
    </div>
    <!-- <v-bottom-sheet v-model="sheet">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="purple"
            dark
            v-bind="attrs"
            v-on="on"
          >
            Open In
          </v-btn>
        </template>
        <v-list>
          <v-subheader>Open in</v-subheader>
          <v-list-item
            v-for="tile in tiles"
            :key="tile.title"
            @click="sheet = false"
          >
            <v-list-item-avatar>
              <v-avatar size="32px" tile>
                <img
                  :src="`https://cdn.vuetifyjs.com/images/bottom-sheets/${tile.img}`"
                  :alt="tile.title"
                >
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-title>{{ tile.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
    </v-bottom-sheet> -->
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
  },
  data() {
    return {
      companyList: [
        {
          label: '个人用户',
          value: ''
        }
      ],
      selectVal: '',
      loading: true
    }
  },
  computed: {
  },
  mounted() {
    this.initData()
  },
  created() {
  },
  methods: {
    async getCompanyList() {
      var that = this
      await that.$api.bz.getCompanyList().then(res => {
        // console.log('获取团队列表', res);
        if (!res.success) {
          // that.$toast.warning('获取团队列表失败');
          console.log('获取团队列表失败', res);
          return;
        }
        var data = res.data
        if (data.length === 0) {
          return
        }
        that.companyList = []
        for (let index = 0; index < data.length; index++) {
          var item = data[index];
          // if (index === data.length - 1) {
          //   that.selectVal = item.COMPANY_CODE
          // }
          that.companyList.push({ label: item.COMPANY_NAME, value: item.COMPANY_CODE })
        }
      })
    },
    async changeCompany() {
      var that = this
      if (!that.selectVal) {
        return
      }
      var res = await that.$api.bz.toggleCompany({ code: that.selectVal })
      // console.log('toggleCompany.res', res);
      if (!res.success) {
        that.$toast.warning('切换失败');
        return;
      }
      // that.$toast.success('切换成功');
      await that.$AppHelper.pullUserCustomData();
      await that.$AppHelper.pullNewUserToken();
      // 尝试修改页面缓存开关
      // var routes = that.$router.options.routes
      // // console.log('之前的routes', routes);
      // for (let index = 0; index < routes.length; index++) {
      //   const element = routes[index];
      //   if (!element.meta) {
      //     continue;
      //   }
      //   var has = 'TempKeep' in element.meta;
      //   if (!has) {
      //     continue;
      //   }
      //   if (!element.meta.TempKeep) {
      //     element.meta.TempKeep = true
      //     // console.log('sss');
      //   }
      // }
      // console.log('之后的routes', routes);
      that.$emit('toggled', that.selectVal)
    },
    clickToggle() {
      var e = window.document.getElementById('us-select');
      e.click();
    },
    async initData() {
      var that = this
      await that.getCompanyList();
      await that.$AppHelper.pullUserCustomData(function(data) {
        var cpy = data.staff_info;
        if (cpy && cpy.COMPANY_CODE) {
          that.selectVal = cpy.COMPANY_CODE;
        }
        that.loading = false
      });
    }
  }
}
</script>

<style scoped>
.us-toggle-company{
  font-size:0.88rem;
  padding-bottom:0.6rem;
  padding-left:1.2rem;
  position: relative;
}
</style>
